<script>
import { layoutMethods } from "@/state/helpers";
import simplebar from "simplebar-vue";

/**
 * Right sidebar component
 */
export default {
  components: {
    simplebar,
  },
  data() {
    return {
      config: {
        handler: this.handleRightBarClick,
        middleware: this.middleware,
        events: ["click"],
      },
      timezone: this.$store ? this.$store.state.layout.timezone : {} || {},
      loader: this.$store ? this.$store.state.layout.loader : {} || {},
    };
  },
  methods: {
    ...layoutMethods,
    hide() {
      this.$parent.toggleRightSidebar();
    },
    // eslint-disable-next-line no-unused-vars
    handleRightBarClick(e, el) {
      this.$parent.hideRightSidebar();
    },
    // eslint-disable-next-line no-unused-vars
    middleware(event, el) {
      if (event.target.classList)
        return !event.target.classList.contains("toggle-right");
    },
    changeloader() {
      return this.changeLoaderValue({
        loader: this.loader,
      });
    },
    changeTimezone() {
      return this.changeTimezoneValue({
        timezone: this.timezone,
      });
    },
  },
};
</script>

<template>
  <div>
    <div v-click-outside="config" class="right-bar">
      <simplebar class="h-100">
        <div class="rightbar-title px-3 py-4">
          <h5 class="m-0">{{ $t("settings.text") }}</h5>
        </div>

        <div class="p-3">
          <h6 class="mb-0">{{ $t("settings.timezone") }}</h6>
          <hr class="mt-1" />
          <b-form-radio-group
            checked="form-check"
            v-model="timezone"
            stacked
            @input="changeTimezone($event)"
          >
            <b-form-radio value="local" class="mb-1 form-check"
              >{{ $t("settings.timezoneLocal") }}</b-form-radio
            >
            <b-form-radio value="utc" class="mb-1 form-check"
              >{{ $t("settings.timezoneUtc") }}</b-form-radio
            >
          </b-form-radio-group>

          <!-- Preloader -->
          <h6 class="mt-3">{{ $t("settings.preloader") }}</h6>
          <hr class="mt-1" />

          <b-form-checkbox
            v-model="loader"
            name="check-button"
            class="form-check"
            @input="changeloader"
            >Preloader</b-form-checkbox
          >
        </div>

      </simplebar>
    </div>

    <!-- Right bar overlay-->
    <div class="rightbar-overlay"></div>
  </div>
</template>
